export default __webpack_public_path__ + "static/media/2.97e46fca.png";